import { defineNuxtPlugin } from '#app'

interface ErrorWithStatus {
  status?: number
  statusCode?: number
  message?: string
  error?: string
  error_description?: string
}

export default defineNuxtPlugin((nuxtApp) => {
  // Zachycení chyb z fetch
  nuxtApp.hook('app:error', (error: unknown) => {
    console.error('App error caught:', error)

    if (error instanceof Response) {
      console.error('Response error:', error.status, error.statusText)
      if (error.status === 500 || error.status === 401) {
        nuxtApp.vueApp.provide('showError500', true)
      }
    }
  })

  // Zachycení chyb z Vue
  nuxtApp.vueApp.config.errorHandler = (error: unknown, instance, info) => {
    console.error('Vue error caught:', error)
    console.error('Component:', instance)
    console.error('Info:', info)

    // Zachytíme TypeError: Failed to fetch
    if (error instanceof TypeError && error.message === 'Failed to fetch') {
      console.error('Network error detected:', error)
      nuxtApp.vueApp.provide('showError500', true)
      return
    }

    const err = error as ErrorWithStatus
    if (err.status === 500 || err.statusCode === 500 || err.error === 'invalid_grant') {
      console.error('500 error detected:', err)
      nuxtApp.vueApp.provide('showError500', true)
    }
  }

  // Zachycení chyb z API
  nuxtApp.hook('app:error', (error: unknown) => {
    console.error('API error caught:', error)

    // Zachytíme TypeError: Failed to fetch
    if (error instanceof TypeError && error.message === 'Failed to fetch') {
      console.error('Network error detected:', error)
      nuxtApp.vueApp.provide('showError500', true)
      return
    }

    const err = error as ErrorWithStatus
    if (err.status === 500 || err.statusCode === 500 || err.error === 'invalid_grant') {
      console.error('500 error detected:', err)
      nuxtApp.vueApp.provide('showError500', true)
    }
  })

  // Zachycení chyb z Supabase
  nuxtApp.hook('app:error', (error: unknown) => {
    console.error('Supabase error caught:', error)

    // Zachytíme TypeError: Failed to fetch
    if (error instanceof TypeError && error.message === 'Failed to fetch') {
      console.error('Network error detected:', error)
      nuxtApp.vueApp.provide('showError500', true)
      return
    }

    if (error && typeof error === 'object' && 'message' in error) {
      const err = error as { message: string }
      if (err.message.includes('invalid_grant') || err.message.includes('JWT expired')) {
        console.error('Auth error detected:', err)
        nuxtApp.vueApp.provide('showError500', true)
      }
    }
  })
})
